import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../../context/AuthContext';
import { customAlert, notify } from '../notify';
import { editComPotProjDetServ } from '../../services/com-service';
import FillLabelTxtField from '../FillLabelTxtField';

function AddPotProjDet({ modalOpen, handleModalClose, selComData }) {
    const { setLoadingScreen } = useAuthContext;
    const queryClient = useQueryClient();
    const theme = useTheme();

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        try {
            const payload = { comId: selComData?.comId, ...inputObject }
            const { message } = await editComPotProjDetServ(payload);
            notify("success", message);
            handleModalClose();
            queryClient.invalidateQueries();
        } catch (err) {
            console.log(err);
            customAlert(err);
        }
    }


    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {selComData ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2.5}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Update Company Project</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">

                        <FillLabelTxtField defaultValue={selComData?.potProjDet} fontSize={15} name="potProjDet" title={"Project"} multiline={true} height={103} width={350} />

                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SAVE</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default AddPotProjDet;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};


